import axios, { InternalAxiosRequestConfig } from 'axios';

const apiClient = axios.create({
//    baseURL: 'http://127.0.0.1:8000/api/',
  baseURL: 'https://py.ksmtechnologies.com.bd/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export default apiClient;